module.exports = __webpack_public_path__ + "img/hat.be5030ca.webp";